<template>
  <div class="form-field">
    <slot name="hidden-field" />

    <slot name="label" :field="field">
      <template v-if="field.title">
        <label v-if="field.labelForId" :for="field.labelForId" class="form-field__label">
          {{ field.title }}
          <span v-if="field.requiredField" class="form-field__required">*</span>
        </label>
        <span v-else class="form-field__label form-field__label--default">
          {{ field.title }}
          <span v-if="field.requiredField" class="form-field__required">*</span>
        </span>
      </template>
    </slot>

    <slot name="description" :description="field.description">
      <p v-if="field.description" class="form-field__description">
        {{ field.description }}
      </p>
    </slot>

    <slot name="default" />

    <slot name="error" :error-text="field.errorText">
      <p class="form-field__error">
        {{ field.errorText }}
      </p>
    </slot>
  </div>
</template>

<script>
export default {
  name: 'FormField',
  props: {
    field: {
      type: Object,
      required: true,
    },
  },
}
</script>

<style scoped lang="sass">
@import "~@src/legacy/sass/params"

.form-field
  display: flex
  flex-direction: column

  &__label, &__description
    display: inline-block
    margin-bottom: 8px
    color: var(--field-text-color, $black)
    font-size: 13px
    line-height: 1.3

    &--default
      cursor: default

  &__required
    color: var(--field-asterisk-color, #EF7171)

  &__error
    min-height: 16px
    margin-top: 2px
    font-size: 12px
    line-height: normal
    color: var(--field-error-text-color, #EF7171)
</style>



// WEBPACK FOOTER //
// src/modules/shared/ui/public/forms/components/FormField.vue